if (!customElements.get("header-offer-countdown")) {
  customElements.define(
    "header-offer-countdown",
    class HeaderOfferCountdown extends HTMLElement {
      connectedCallback() {
        const raw = (this.dataset.deadline || "").trim();
        const deadline = Date.parse(raw);
        const removeRoot = () => {
          this.closest("[data-sale-countdown-root]")?.remove() ||
            this.closest(".header-offer-timer")?.remove() ||
            this.closest(".cart-drawer-timer")?.remove() ||
            this.closest(".cart-countdown-time")?.remove();
        };

        if (!Number.isFinite(deadline)) {
          removeRoot();
          return;
        }

        const pad = (n) => String(Math.max(0, n)).padStart(2, "0");

        const setUnit = (unit, value) => {
          const el = this.querySelector(`[data-unit="${unit}"]`);
          if (!el) return;
          const next = pad(value);
          if (el.textContent === next) return;
          el.textContent = next;
          el.classList.remove("is-tick");
          void el.offsetWidth;
          el.classList.add("is-tick");
          window.setTimeout(() => el.classList.remove("is-tick"), 220);
        };

        const stop = () => {
          if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
          }
        };

        const tick = () => {
          const diff = deadline - Date.now();
          if (diff <= 0) {
            stop();
            removeRoot();
            return false;
          }

          setUnit("days", Math.floor(diff / 86400000));
          setUnit("hours", Math.floor((diff / 3600000) % 24));
          setUnit("minutes", Math.floor((diff / 60000) % 60));
          setUnit("seconds", Math.floor((diff / 1000) % 60));
          return true;
        };

        if (tick()) {
          this._timer = setInterval(tick, 1000);
        }
      }

      disconnectedCallback() {
        if (this._timer) {
          clearInterval(this._timer);
          this._timer = null;
        }
      }
    }
  );
}
